import ReactDOM from "react-dom/client";
import App from "./App";

// Render the App component
const root = ReactDOM.createRoot(document.getElementById("root"));
// Compare this snippet from src/index.js:
root.render(<App />);
